import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

type ConfigContextType = {
  companyId: string;
  apiUrl: string;
};

export const ConfigContext = createContext<ConfigContextType>({} as any);

export const useConfigContext = () => useContext(ConfigContext);
